<script lang="ts">
  /*
   * Geometry is the read-only design source verbatim: every rect, polyline, line,
   * and gradient stop below is copied coordinate-for-coordinate from
   * EpiDevWebSite `site/favicon.svg` (the same mark the site inlines in its .brand
   * lockup) on the shared 0 0 1024 1024 viewBox. Redrawing it by eye, or pulling it
   * from an icon package, would let the portal's mark drift from the site's — so
   * there is no icon dependency here and none should be added. Sized via prop.
   */
  interface Props {
    size?: number;
    title?: string;
  }
  const { size = 28, title = "EpiDev" }: Props = $props();
  // Several logos render per document (splash, sidebar, topbar) — the gradient id
  // must be unique or every `url(#…)` resolves to the first instance.
  const gradientId = "epidev-logo-bg-" + Math.random().toString(36).slice(2, 8);
</script>

<svg
  viewBox="0 0 1024 1024"
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  role="img"
  aria-label={title}
  class="app-logo"
>
  <defs>
    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#17222F" />
      <stop offset="1" stop-color="#0A1018" />
    </linearGradient>
  </defs>
  <rect width="1024" height="1024" rx="228" fill="url(#{gradientId})" />
  <g fill="#33C5F2">
    <rect x="228" y="228" width="568" height="152" rx="34" />
    <rect x="228" y="228" width="142" height="240" rx="34" />
    <rect x="228" y="644" width="568" height="152" rx="34" />
    <rect x="228" y="556" width="142" height="240" rx="34" />
  </g>
  <g fill="none" stroke="#33C5F2" stroke-width="44" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="448,460 384,512 448,564" />
    <line x1="504" y1="572" x2="580" y2="452" />
    <polyline points="636,460 700,512 636,564" />
  </g>
</svg>

<style>
  .app-logo {
    display: block;
    flex: none;
  }
</style>
